import React from 'react';
import './HydrologyAI.css';

function HydrologyAI() {
  return (
    <div className="hydrology-container">
      <div className="hydrology-header">
        <h1>Hydrology AI</h1>
        <p className="subtitle">AI-Powered Hydrological Analysis and Compliance</p>
      </div>

      <div className="hydrology-content">
        <div className="development-notice">
          <h2>🚧 Under Development</h2>
          <p>
            The Hydrology AI agent is currently under development. It is intended to run 
            locally on the hydrologist's computer, rather than on the web. Ellipsoid Labs 
            is currently seeking a hydrologist, as the subject matter expert, to collaborate 
            with in developing this AI agent.
          </p>
        </div>

        <div className="ai-description">
          <h2>About the Hydrology AI Agent</h2>
          <p>
            The Hydrology AI agent assists Hydrologists with analysis and compliance tasks. 
            This AI enhances Hydrologist's productivity and assists with the complex 
            regulatory environment and the analyses of their projects. The AI interfaces 
            with ArcGIS Pro hydrologic models and other domain-specific applications. 
            This last point is key, as hydrologists use several software tools in their 
            projects, so the scope of this new Hydrology AI agent will span and help 
            integrate these tools.
          </p>
          <p>
            The Hydrologist AI is the first of several domain-specific AIs that we are 
            considering developing. Our goal is to create specialized AI agents that 
            understand the unique challenges and workflows of different GIS-related 
            professions.
          </p>
        </div>
      </div>
    </div>
  );
}

export default HydrologyAI;
